export function sortDataByFieldName(
  conditionData: any,
  sortByField: string
): any[] {
  if (!conditionData?.length) {
    return conditionData;
  }
  return conditionData.sort((a: any, b: any) => {
    const extractParts = (input: string) => {
      const str = typeof input === 'string' ? input : '';
      const match = str.match(/^(\d+)/);
      if (match) {
        return {
          num: parseInt(match[1], 10),
          rest: str.slice(match[0].length).trim().toLowerCase(),
          isNumeric: true,
        };
      }
      return {
        num: null,
        rest: str.toLowerCase(),
        isNumeric: false,
      };
    };

    const valueA = a?.[sortByField] ?? '';
    const valueB = b?.[sortByField] ?? '';
    const partA = extractParts(valueA);
    const partB = extractParts(valueB);
    if (partA?.isNumeric && partB?.isNumeric) {
      if (partA.num! !== partB.num!) {
        return partA.num! - partB.num!;
      }
      return partA.rest.localeCompare(partB.rest);
    }
    if (partA.isNumeric) {
      return -1;
    }
    if (partB.isNumeric) {
      return 1;
    }
    return partA.rest.localeCompare(partB.rest);
  });
}
